// Bump version to refresh seeded demo data (avoids mixing old demo data with updated placeholders)
const DEMO_DB_KEY = "demoDb_v8";

const initialDemoDb = {
  // Minimal demo user-facing entities; extend as needed per screens
  smsTemplates: [
    { id: 1, name: "Тестовий шаблон 1", text: "ТЕСТ: Доброго дня! Нагадуємо про заборгованість..." },
    { id: 2, name: "Тестовий шаблон 2", text: "ТЕСТ: Просимо сплатити заборгованість найближчим часом." },
  ],
  smsHistory: [],
  debtors: [
    { id: 1, name: "Тестовий боржник 1", phone: "+380000000001", total_debt: 3500.5 },
    { id: 2, name: "Тестовий боржник 2", phone: "+380000000002", total_debt: 1200.0 },
    { id: 3, name: "Тестовий боржник 3", phone: "+380000000003", total_debt: 0.0 },
  ],
  communitySettingsPublic: {
    altCityName: "Демо громада",
  },
  owerSettingsPublic: {},
  kindergartenBilling: {
    items: [],
    totalItems: 0,
    currentPage: 1,
    totalPages: 0,
  },
  // Demo-only UI overrides
  menuOverrides: {
    // Опційні перейменування за module_id; за замовчуванням store.js нумерує «Тестовий садочок N».
    moduleNameById: {},
  },
};

function clone(obj) {
  // structuredClone isn't available in all environments; JSON clone is sufficient for demo data
  return JSON.parse(JSON.stringify(obj));
}

export function loadDemoDb() {
  try {
    const raw = localStorage.getItem(DEMO_DB_KEY);
    return raw ? JSON.parse(raw) : clone(initialDemoDb);
  } catch (e) {
    return clone(initialDemoDb);
  }
}

export function saveDemoDb(db) {
  try {
    localStorage.setItem(DEMO_DB_KEY, JSON.stringify(db));
  } catch (e) {
  }
}

export function resetDemoDb() {
  try {
    localStorage.removeItem(DEMO_DB_KEY);
  } catch (e) {
  }
}

